import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/allproducts/rootin-1.25.jpeg";
// import thumb1 from "../assets/images/All-Products/rootin2-5.png";
import thumb2 from "../assets/images/allproducts/rootin-1.25.jpeg";
// import thumb3 from "../assets/images/All-Products/rootINF.png";
import howToUseThumb from "../assets/images/hair-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/hair-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Transforming Hair Health Through Scientific Innovation."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Hair Care", to: "/HairCareProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Root IN 1.25</h2>
              <p className="sub-heading text-muted">Effective treatment for AGA</p>
              <h5>Product Overview</h5>
              <p>
                Hair loss can often persist despite topical treatments, especially in cases where follicular
                response is limited. Minoxidil 1.25 mg Tablet offers an advanced, systemic approach to
                support hair regrowth from within.
                Originally developed as a vasodilator, low-dose oral minoxidil is now widely used under
                medical supervision to help improve hair density, thickness, and overall scalp coverage
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Root IN 1.25?</span>
                </h3>
                <p>
                  Typically prescribed as initial dosage. Must be taken only under medical supervision
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "Side_effects", "ingredients", "available_as"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "Side_effects"
                      ? "SIDE EFFECTS"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "available_as"
                          ? "AVAILABLE AS"
                          : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>1. Benefits</strong></p>
                  <ul>
                    <li>Clinical studies show improved total hair density in the frontal region after 24 weeks.</li>
                    <li>Density of terminal hair in the vertex region improved after 24 weeks.</li>
                    <li>New terminal hair observed in both vertex and frontal regions.</li>
                    <li>Improvement in blood microcirculation.</li>
                  </ul>


                </div>
              )}
              {activeTab === "Side_effects" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Fluid retention (causing weight gain and/or ankle swelling)</li>
                      <li>Low blood pressure (may cause dizziness / fainting)</li>
                      <li>Increased body hair growth, skin rashes</li>
                      <li>Increased heart rate (fast pulse / palpitations)</li>
                      <li>Pericarditis / pericardial effusion (causing chest pain and/or shortness of breath)</li>
                      <li>Nausea and vomiting</li>
                      <li>Breast tenderness</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>

                    <strong class="me-1">Minoxidil:</strong>
                    Minoxidil functions as a potassium channel opener, which works by hyperpolarizing the cell membrane.
                    This process widens blood vessels and enhances blood flow to the hair follicles by opening potassium channels,
                    allowing more oxygen, nutrients, and blood to reach the follicles. This increased circulation promotes healthier follicles and encourages the transition from the telogen (resting) phase to the anagen (growth) phase.
                    As a result, hair follicles that were previously in the telogen phase shed, and are replaced by thicker, stronger, and healthier hair during the new anagen phase, leading to visible hair regrowth increased hair density over time.
                    Minoxidil works to relieve hypertension by acting as a vasodilator. This same vasodilatory property is responsible for the effectiveness of Minoxidil in stimulating hair re-growth.

                  </p>
                </div>
              )}
              {activeTab === "available_as" && (
                <div className="tab-content fade-in">
                  <p>

                    1.25 mg and 2.5 mg (white, round, scored)
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
